import { defineMessages } from 'react-intl';

export default defineMessages({
  back: {
    id: 'neptune.FlowNavigation.back',
    defaultMessage: 'back to previous step',
  },
});
